import React from 'react';
import ListingSelect from '../../listing/js/ListingSelect';
import PropTypes from "prop-types";

export default class NewsSearchControls extends React.PureComponent {

    render() {
        return (
            <div className="listing-controls__content-inner">
                <div className="listing-controls__right">

                    {this.props.options.filters.map(filterConfig => (
                        <ListingSelect
                            key={filterConfig.name}
                            config={filterConfig}
                            value={this.props.filters[filterConfig.name]}
                            onChange={this.props.onFiltersChange}>
                        </ListingSelect>
                    ))}

                </div>
            </div>
        );
    }
}

NewsSearchControls.defaultProps = {
    options: {
        //filters config
        filters: [],
    }
};

NewsSearchControls.propTypes = {
    onFiltersChange: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    options: PropTypes.object,
};



// WEBPACK FOOTER //
// ./app/components/news-search/js/NewsSearchControls.js